import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


// Services
import { HttpService } from 'src/app/modules/shared/services/http.service';

// Models
import { ChannelN } from '../models/channel.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class SharedChannelService {
    baseConfigURL: string;

    constructor(
        private httpService: HttpService,
        private http: HttpClient
        ) {
        this.baseConfigURL = environment.configUrlV2;
    }

    getChannels(moduleId: number, allList: boolean = false): Observable<ChannelN[]> {
        if(!allList){
            return this.httpService.getAll(`${this.baseConfigURL}/Channel/SelectList/Module/${moduleId}`);
        }else {
            return this.getAllChannels(moduleId);
        }
    }

    getAllChannels(moduleId: number): Observable<ChannelN[]> {
        return this.httpService.getAll(`${this.baseConfigURL}/Channel/SelectAllowedList/Module/${moduleId}`);
    }

    getChannelWiseUsers(channelId: number,moduleId: number): Observable<any[]> {
        return this.httpService.getAll(`${environment.appOrgUrl}User/GetAllChannelUser?channelId=${channelId}&moduleId=${moduleId}&includeDeleted=false&inActive=false&both=true`);
    }

    getOpportunityNameListUserWise(search?, channelId?: number, userId?: number) {
        return this.http.get(`${environment.accountOpportunityUrl}Opportunity/UserOpportunitysWithName?userId=${userId}&isTerritory=true&search=${search}&channelId=${channelId}`);
    }

    getLeadNameListUserWise(search, channelId: number, userId: number) {
        return this.http.get(`${environment.apiUrlLead}LeadAPI/Lead/UserLeadsWithName?userId=${userId}&isTerritory=true&search=${search}&channelId=${channelId}`);
    }

    getCasesNameListUserWise(userId?: number, data?) {
        return this.http.post(`${environment.accountCasesUrl}Ticket/v2/GetUserPagedList/${userId}`, data);
    }

    getAccountNameListUserWise(search?, channelId?: number, userId?: number) {
        return this.http.get(`${environment.apiUrlAccount}Account/UserAccountsWithName?userId=${userId}&isTerritory=true&search=${search}&channelId=${channelId}`);
    }

    moduleWiseUserListTask(moduleTypeId:any, associationId:any){
        return this.http.get(`${environment.appOrgUrl}User/GetAllModuleUser?moduleTypeId=${moduleTypeId}&associationId=${associationId}`);
    }
}
